export default __webpack_public_path__ + "static/media/faqArrowRight.46ff26bb.svg";